import React from 'react';
import styled from 'styled-components';
import { Modal, Button } from '@cityelectricalfactors/ui-components';

const ApprovalsGroupMessageModal = ({
  options,
  closeModal,
  removeUserHandler,
}) => {
  const { showModal, title, description, cta } = options;

  return (
    <ApprovalModal isOpen={showModal} closeModal={closeModal}>
      <h2 className="ff-rc fw-700 fs-20 lh-1-3 tc-grey-70 mb-12">{title}</h2>
      <p className="ff-r fs-16 lh-1-3 tc-grey-70 mb-35">{description}</p>
      <div className="fl jc-fe">
        <Button
          className="cef-btn cef-btn--large bg-grey-70 tc-white mr-14"
          handleClick={closeModal}>
          Cancel
        </Button>
        <Button
          className="cef-btn cef-btn--large bg-cef-red tc-white"
          handleClick={removeUserHandler}>
          {cta}
        </Button>
      </div>
    </ApprovalModal>
  );
};

const ApprovalModal = styled(Modal)`
  background-color: rgba(0, 0, 0, 0.7);
  & > div {
    box-sizing: border-box;
    width: 100%;
    max-width: 475px;
    height: 243px;
    padding: 32px 24px 28px 30px;
  }
`;

export default ApprovalsGroupMessageModal;
